export default __webpack_public_path__ + "static/media/doopage_logo_color.63a47070.png";